// localStorage с защитой: в WebView и приватном режиме доступ может бросать исключение (ux/12 §5.4: DeviceStorage — с 9.0).
const PREFIX = 'garages.';

export const storage = {
  get(key: string): string | null {
    try { return globalThis.localStorage?.getItem(PREFIX + key) ?? null; } catch { return null; }
  },
  set(key: string, value: string): void {
    try { globalThis.localStorage?.setItem(PREFIX + key, value); } catch { /* нет места или запрещено — не критично */ }
  },
  remove(key: string): void {
    try { globalThis.localStorage?.removeItem(PREFIX + key); } catch { /* то же */ }
  },
  getJson<T>(key: string): T | null {
    const raw = storage.get(key);
    if (raw === null) return null;
    try { return JSON.parse(raw) as T; } catch { return null; }
  },
  setJson(key: string, value: unknown): void {
    storage.set(key, JSON.stringify(value));
  },
};
